enum FilterType {
	INPUT = "input",
	SELECT = "select",
}

export { FilterType };
